
	/**
	 * @description
	 *  Modelo del tipo de migración.
	 *
	 * @see gigot-backend/Core/Concept/MigrationType.cs
	 */

export enum MigrationType {

	CreateStructureIfNotExists,
	UseDefaultStructure
}

export const toMigrationTypeString = (migrationType: MigrationType): string => {
	switch (migrationType) {
		case MigrationType.CreateStructureIfNotExists:
			return "Crear estructura en campaña destino si no existe.";
		case MigrationType.UseDefaultStructure:
			return "Mover revendedoras al área ZZZ09 si el área destino no existe.";
		default: {
			return "[Unknown MigrationType]";
		}
	}
};
